/**
 * This experience id matches the current ultra lux airport transfer
 * and the loyalty transfer.
 * This is the transfer agents will purchase for users when they redeem
 * a airport transfer loyalty benefit
 */
export const loyaltyTransferExperienceId = 'led:006RF00000G3wMPYAZ'
export const magicLoyaltyTransferExperienceIds: Set<string> = new Set([
  'led:006Ii000002ItIXIA0', // Ultra Lux
  loyaltyTransferExperienceId,
])
/**
 * This matches the exact ticket ID of the experiences above that is to be made 'free'
 * when redeeming an aiport loyalty benefit
 *
 * NOTE: Ticket ids are stable across location/date changes, at least for these experiences
 */
export const magicLoyaltyTransferExperienceTicketIds: Set<string> = new Set(['a0sIi000000c46kIAA', 'a0sRF00000F1aYfYAJ'])
